import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Returns the set of custom-action keys granted to the current user.
 * Used to gate per-row and bulk action buttons in the UI.
 */
export function useUserActions(): { actions: Set<string>; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['/auth/me/actions'],
    queryFn: async () => (await api<string[]>('/auth/me/actions')).data || [],
    staleTime: 5 * 60 * 1000,
  });
  return { actions: new Set(data ?? []), isLoading };
}
